import { render, staticRenderFns } from "./ed-homework-course-material-object.vue?vue&type=template&id=f32dfa6e&scoped=true&"
import script from "./ed-homework-course-material-object.ts?vue&type=script&lang=ts&"
export * from "./ed-homework-course-material-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homework-course-material-object.scss?vue&type=style&index=0&id=f32dfa6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32dfa6e",
  null
  
)

export default component.exports